const isFilterEmpty = (filterData, emptyFilterData) => {
  const keys = Object.keys(emptyFilterData);
  let isEmpty = true;
  keys.map((key) => {
    if (
      filterData[key] !== undefined &&
      filterData[key] !== emptyFilterData[key]
    )
      isEmpty = false;
  });
  return isEmpty;
};

export const checkFilterIconVisibility = (
  filterData,
  emptyFilterData,
  cardList,
) => {
  const x = isFilterEmpty(filterData, emptyFilterData);
  const y = cardList?.length === 0;
  if (x & y) return false;
  return true;
};
